/**
 * Запрос на автоматическое создание рейсов
 */
export class OptimizationTaskAutoBuildTransportsRequest {
  desiredArrivalDate: string;
  desiredArrivalTimeBegin: string;
  desiredArrivalTimeEnd: string;
  isRouteOptimizationEnabled: boolean;
}